export default __webpack_public_path__ + "static/media/sphere2.81daceec.svg";